import React from "react";
import PropTypes from "prop-types";
import { CardContainer, NumberStyled, TextStyled } from "./Cards.styled";

const Card = (props) => {
  return (
    <CardContainer $color={props.bgColor}>
      <NumberStyled>{props.number}</NumberStyled>
      <TextStyled>{props.text}</TextStyled>
    </CardContainer>
  );
};

Card.propTypes = {
  bgColor: PropTypes.string,
  number: PropTypes.string,
  text: PropTypes.string,
};
export default Card;
